(function ($) {
	"use strict";
    window.SuperflyView = Backbone.View.extend({
        bindings: function () { // bindings for input fields
            var result = {};

            result['[name*="sf_options[sf_active_menu]"]']           = 'sf_active_menu';
            result['[name*="sf_options[sf_alternative_menu]"]']      = 'sf_alternative_menu';
            result['[name*="sf_options[sf_test_mode]"]']             = 'sf_test_mode';
            result['[name*="sf_options[sf_display]"]']               = 'sf_display';

            result['[name*="sf_options[sf_sidebar_style]"]']         = 'sf_sidebar_style';
            result['[name*="sf_options[sf_sidebar_behaviour]"]']     = 'sf_sidebar_behaviour';
            result['[name*="sf_options[sf_sidebar_pos]"]']           = 'sf_sidebar_pos';
            result['[name*="sf_options[sf_skew_type]"]']             = 'sf_skew_type';
            result['[name*="sf_options[sf_fs_layout]"]']             = 'sf_fs_layout';
            result['[name*="sf_options[sf_opening_type]"]']          = 'sf_opening_type';
            result['[name*="sf_options[sf_sub_type]"]']              = 'sf_sub_type';
            result['[name*="sf_options[sf_sub_opening_type]"]']      = 'sf_sub_opening_type';
            result['[name*="sf_options[sf_fade_content]"]']          = 'sf_fade_content';
            result['[name*="sf_options[sf_fade_full]"]']             = 'sf_fade_full';
            result['[name*="sf_options[sf_full_sec]"]']              = 'sf_full_sec';
            result['[name*="sf_options[sf_full_head]"]']             = 'sf_full_head';
            result['[name*="sf_options[sf_full_x]"]']                = 'sf_full_x';
            result['[name*="sf_options[sf_blur_content]"]']          = 'sf_blur_content';
            result['[name*="sf_options[sf_transparent_panel]"]']     = 'sf_transparent_panel';
            result['[name*="sf_options[sf_transition]"]']            = 'sf_transition';

            result['[name*="sf_options[sf_width_panel_1]"]']         = 'sf_width_panel_1';
            result['[name*="sf_options[sf_bg_color_panel_1]"]']      = 'sf_bg_color_panel_1';
            result['[name*="sf_options[sf_color_panel_1]"]']         = 'sf_color_panel_1';
            result['[name*="sf_options[sf_scolor_panel_1]"]']        = 'sf_scolor_panel_1';
            result['[name*="sf_options[sf_hover_panel_1]"]']         = 'sf_hover_panel_1';
            result['[name*="sf_options[sf_image_bg]"]']              = 'sf_image_bg';
            result['[name*="sf_options[sf_width_panel_2]"]']         = 'sf_width_panel_2';
            result['[name*="sf_options[sf_bg_color_panel_2]"]']      = 'sf_bg_color_panel_2';
            result['[name*="sf_options[sf_color_panel_2]"]']         = 'sf_color_panel_2';
            result['[name*="sf_options[sf_scolor_panel_2]"]']        = 'sf_scolor_panel_2';
            result['[name*="sf_options[sf_hover_panel_2]"]']         = 'sf_hover_panel_2';
            result['[name*="sf_options[sf_width_panel_3]"]']         = 'sf_width_panel_3';
            result['[name*="sf_options[sf_bg_color_panel_3]"]']      = 'sf_bg_color_panel_3';
            result['[name*="sf_options[sf_color_panel_3]"]']         = 'sf_color_panel_3';
            result['[name*="sf_options[sf_scolor_panel_3]"]']        = 'sf_scolor_panel_3';
            result['[name*="sf_options[sf_hover_panel_3]"]']         = 'sf_hover_panel_3';
            result['[name*="sf_options[sf_width_panel_4]"]']         = 'sf_width_panel_4';
            result['[name*="sf_options[sf_bg_color_panel_4]"]']      = 'sf_bg_color_panel_4';
            result['[name*="sf_options[sf_color_panel_4]"]']         = 'sf_color_panel_4';
            result['[name*="sf_options[sf_scolor_panel_4]"]']        = 'sf_scolor_panel_4';
            result['[name*="sf_options[sf_hover_panel_4]"]']         = 'sf_hover_panel_4';
            result['[name*="sf_options[sf_chapter_1]"]']             = 'sf_chapter_1';
            result['[name*="sf_options[sf_chapter_2]"]']             = 'sf_chapter_2';
            result['[name*="sf_options[sf_chapter_3]"]']             = 'sf_chapter_3';
            result['[name*="sf_options[sf_chapter_4]"]']             = 'sf_chapter_4';

            result['[name*="sf_options[sf_tab_logo]"]']              = 'sf_tab_logo';
            result['[name*="sf_options[sf_logo_size]"]']             = 'sf_logo_size';
            result['[name*="sf_options[sf_first_line]"]']            = 'sf_first_line';
            result['[name*="sf_options[sf_sec_line]"]']              = 'sf_sec_line';

            result['[name*="sf_options[sf_facebook]"]']              = 'sf_facebook';
            result['[name*="sf_options[sf_dribbble]"]']              = 'sf_dribbble';
            result['[name*="sf_options[sf_twitter]"]']               = 'sf_twitter';
            result['[name*="sf_options[sf_youtube]"]']               = 'sf_youtube';
            result['[name*="sf_options[sf_linkedin]"]']              = 'sf_linkedin';
            result['[name*="sf_options[sf_vimeo]"]']                 = 'sf_vimeo';
            result['[name*="sf_options[sf_gplus]"]']                 = 'sf_gplus';
            result['[name*="sf_options[sf_soundcloud]"]']            = 'sf_soundcloud';
            result['[name*="sf_options[sf_instagram]"]']             = 'sf_instagram';
            result['[name*="sf_options[sf_email]"]']                 = 'sf_email';
            result['[name*="sf_options[sf_pinterest]"]']             = 'sf_pinterest';
            result['[name*="sf_options[sf_skype]"]']                 = 'sf_skype';
            result['[name*="sf_options[sf_flickr]"]']                = 'sf_flickr';
            result['[name*="sf_options[sf_rss]"]']                   = 'sf_rss';

            result['[name*="sf_options[sf_social_style]"]']          = 'sf_social_style';
            result['[name*="sf_options[sf_social_color]"]']          = 'sf_social_color';
            result['[name*="sf_options[sf_social_align]"]']          = 'sf_social_align';

            result['[name*="sf_options[sf_search]"]']                = 'sf_search';
            result['[name*="sf_options[sf_search_bg]"]']             = 'sf_search_bg';
            result['[name*="sf_options[sf_copy]"]']                  = 'sf_copy';

            result['[name*="sf_options[sf_font]"]']                  = 'sf_font';
            result['[name*="sf_options[sf_font_size]"]']             = 'sf_font_size';
            result['[name*="sf_options[sf_font_weight]"]']           = 'sf_font_weight';
            result['[name*="sf_options[sf_alignment]"]']             = 'sf_alignment';
            result['[name*="sf_options[sf_uppercase]"]']             = 'sf_uppercase';
            result['[name*="sf_options[sf_spacing]"]']               = 'sf_spacing';
            result['[name*="sf_options[sf_c_font]"]']                = 'sf_c_font';
            result['[name*="sf_options[sf_c_fs]"]']                  = 'sf_c_fs';
            result['[name*="sf_options[sf_c_weight]"]']              = 'sf_c_weight';
            result['[name*="sf_options[sf_c_trans]"]']               = 'sf_c_trans';

            result['[name*="sf_options[sf_padding]"]']               = 'sf_padding';
            result['[name*="sf_options[sf_padding_h]"]']             = 'sf_padding_h';
            result['[name*="sf_options[sf_icon_size]"]']             = 'sf_icon_size';
            result['[name*="sf_options[sf_icon_color]"]']            = 'sf_icon_color';
            result['[name*="sf_options[sf_fs_dynamic]"]']            = 'sf_fs_dynamic';
            result['[name*="sf_options[sf_ordered]"]']               = 'sf_ordered';
            result['[name*="sf_options[sf_ind]"]']                   = 'sf_ind';
            result['[name*="sf_options[sf_ind_st]"]']                = 'sf_ind_st';
            result['[name*="sf_options[sf_ind_s]"]']                 = 'sf_ind_s';
            result['[name*="sf_options[sf_separators]"]']            = 'sf_separators';
            result['[name*="sf_options[sf_separators_color]"]']      = 'sf_separators_color';
            result['[name*="sf_options[sf_separators_width]"]']      = 'sf_separators_width';
            result['[name*="sf_options[sf_highlight]"]']             = 'sf_highlight';
            result['[name*="sf_options[sf_hover_style]"]']           = 'sf_hover_style';
            result['[name*="sf_options[sf_highlight_active]"]']      = 'sf_highlight_active';

            result['[name*="sf_options[sf_label_vis]"]']             = 'sf_label_vis';
            result['[name*="sf_options[sf_label_type]"]']            = 'sf_label_type';
            result['[name*="sf_options[sf_fixed]"]']                 = 'sf_fixed';
            result['[name*="sf_options[sf_mob_nav]"]']               = 'sf_mob_nav';
            result['[name*="sf_options[sf_threshold_point]"]']       = 'sf_threshold_point';
            result['[name*="sf_options[sf_label_top]"]']             = 'sf_label_top';
            result['[name*="sf_options[sf_label_top_mobile]"]']      = 'sf_label_top_mobile';
            result['[name*="sf_options[sf_label_shift]"]']           = 'sf_label_shift';

            result['[name*="sf_options[sf_label_icon]"]']            = 'sf_label_icon';
            result['[name*="sf_options[sf_label_size]"]']            = 'sf_label_size';
            result['[name*="sf_options[sf_label_style]"]']           = 'sf_label_style';
            result['[name*="sf_options[sf_label_width]"]']           = 'sf_label_width';
            result['[name*="sf_options[sf_label_gaps]"]']            = 'sf_label_gaps';
            result['[name*="sf_options[sf_label_color]"]']           = 'sf_label_color';
            result['[name*="sf_options[sf_label_icon_color]"]']      = 'sf_label_icon_color';
            result['[name*="sf_options[sf_label_text]"]']            = 'sf_label_text';
            result['[name*="sf_options[sf_label_text_color]"]']      = 'sf_label_text_color';

            result['[name*="sf_options[sf_css]"]']                   = 'sf_css';
            result['[name*="sf_options[sf_submenu_support]"]']       = 'sf_submenu_support';
            result['[name*="sf_options[sf_submenu_mob]"]']           = 'sf_submenu_mob';
            result['[name*="sf_options[sf_submenu_classes]"]']       = 'sf_submenu_classes';
            result['[name*="sf_options[sf_togglers]"]']              = 'sf_togglers';
            result['[name*="sf_options[sf_dev]"]']                   = 'sf_dev';

            result['[name*="sf_options[sf_license_name]"]']          = 'sf_license_name';
            result['[name*="sf_options[sf_license_email]"]']         = 'sf_license_email';
            result['[name*="sf_options[sf_license_code]"]']          = 'sf_license_code';

            result['[name*="display_default_menu"]']                 = 'display_default_menu';

            result[
                '.sf_label_type,\
                .sf_fixed,\
                .sf_mob_nav,\
                .sf_threshold_point,\
                .sf_label_top,\
                .sf_label_top_mobile,\
                .sf_label_shift,\
                .sf_label_shift_m,\
                .sf_label_icon,\
                .sf_label_size,\
                .sf_label_style,\
                .sf_label_width,\
                .sf_label_gaps,\
                .sf_label_color,\
                .sf_label_icon_color,\
                .sf_label_text,\
                .sf_label_text_color,\
                h1#stylings'
                ] = {
                observe: 'sf_label_vis',
                update: function ($el, val, model, options) {
                    $el.each(function (i, item) {
                        $(item).hide();
                    });
                    if (val == 'yes') {
                        $el.each(function (i, item) {
                            $(item).show();
                        });
                    }
                }
            }

            result['.sf_sidebar_style'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    if (val == 'toolbar') model.set('sf_sidebar_behaviour', 'always');
                    else if (val == 'full') {
                        model.set('sf_sidebar_behaviour', 'slide');
                    }
                }
            };

            result['.skew-disclaimer'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'skew') $el.show();
                }
            };
            result['.fs-disclaimer'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'full') $el.show();
                }
            };

            result['.sf_sidebar_behaviour'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'side' || val == 'skew') $el.css('display', 'inline-block');
                }
            };

            result['.sf_skew_type'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'skew') $el.css('display', 'inline-block');
                }
            };

            result['.sf_fs_layout'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'full') $el.css('display', 'inline-block');
                }
            };

            result['.sf_transparent_panel'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.css('display', 'inline-block');
                    if (val == 'full') $el.hide();
                }
            };

            result['.sf_fade_content'] = {
                observe: [
                    'sf_sidebar_behaviour',
                    'sf_sidebar_style'
                ],
                update: function ($el, val, model, options) {
                    $el.css('display', 'inline-block');
                    if (
                        (val[0] == 'always' && val[1] == 'skew') ||
                        val[1] == 'full'
                    ) $el.hide();
                }
            };

            result['.sf_sub_opening_type'] = {
                observe: [
                    'sf_sidebar_style'
                ],
                update: function ($el, val, model, options) {
                    $el.css('display', 'inline-block');
                    if (val == 'skew') $el.hide();
                }
            };

            result['.sf_blur_content'] = {
                observe: [
                    'sf_sidebar_behaviour',
                    'sf_sidebar_style'
                ],
                update: function ($el, val, model, options) {
                    $el.css('display', 'inline-block');
                    if (
                        (val[0] == 'always' && val[1] == 'skew') ||
                        val[1] == 'full'
                    )$el.hide();
                }
            };

            result['.sf_fade_full'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'full') $el.css('display', 'inline-block');
                }
            };

            result['.sf_full_sec'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'full') $el.css('display', 'inline-block');
                }
            };

            result['.sf_full_head'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'full') $el.css('display', 'inline-block');
                }
            };

            result['.sf_full_x'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if (val == 'full') $el.css('display', 'inline-block');
                }
            };

            result['.sf_sub_type'] = {
                observe: 'sf_sidebar_style',
                update: function ($el, val, model, options) {
                    $el.css('display', 'inline-block');
                    if ( val != 'side' ) $el.hide();
                }
            };

            result['.sf_sub_opening_type'] = {
                observe: 'sf_sub_type',
                update: function ($el, val, model, options) {
                    $el.css('display', 'inline-block');
                    if (val != 'flyout') $el.hide();
                }
            };

            result['.sf_opening_type'] = {
                observe: [
                    'sf_sidebar_behaviour',
                    'sf_sidebar_style'
                ],
                update: function ($el, val, model, options) {
                    $el.css('display', 'inline-block');
                    if ( val[1] == 'toolbar' || val[1] == 'full') {
                        $el.hide();
                    }
                }
            };

            result['.sf_ind_s'] = {
                observe: 'sf_ind',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val != '') $el.show();
                }
            };

            result['.sf_ind_st'] = {
                observe: 'sf_ind',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val != '') $el.show();
                }
            };

            result['.sf_separators_color'] = {
                observe: 'sf_separators',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val != '') $el.show();
                }
            };

            result['.sf_separators_width'] = {
                observe: 'sf_separators',
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val != '') $el.show();
                }
            };

            result['.sf_label_text_field'] = {
                observe: ['sf_label_text', 'sf_label_vis'],
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val[0] == 'yes' && val[1] == 'yes') $el.css('display', 'inline-block');
                }
            };

            result['.sf_label_width'] = {
                observe: ['sf_label_type', 'sf_label_vis'],
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val[0] == 'default' && val[1] && val[1] == 'yes') $el.show();
                }
            };

            result['.sf_label_gaps'] = {
                observe: ['sf_label_type', 'sf_label_vis'],
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val[0] == 'default' && val[1] && val[1] == 'yes') $el.show();
                }
            };

            result['.sf_label_icon'] = {
                observe: ['sf_label_type', 'sf_label_vis'],
                update: function ($el, val, model, options) {
                    $el.hide();
                    if(val[0] == 'custom' && val[1] && val[1] == 'yes') $el.show();
                }
            };

            result['.sf-menu__loc_popup .dw_pages_wrap'] = {
                observe: ['display_default_menu'],
                update: function ($el, val, model, options) {
                    console.log('fire');
                    $el.show();
                    if(val)
                        $el.hide();
                }
            };

            return result;
        },
        render: function () {
            this.stickit();
            return this;
        },
        close: function () {
            this.unstickit();
        }
    });
})(jQuery);